// getTripCounts — pure derivation of the flight/hotel/car-rental count summary.
//
// Extracted verbatim from `EditTripModal.js` (the "Trip Info" header counters
// `trip.flights?.length || 0`, `trip.hotels?.length || 0`,
// `trip.carRentals?.length || 0`) as part of the behavior-preserving refactor
// (issue #240). It returns the three counts the header displays.
//
// Totality preserved exactly: each count uses optional chaining on the array
// (`?.length`) with a `|| 0` fallback, reproduced verbatim, so missing/empty
// lists yield `0`. Matching the source, `trip` itself is read directly (the
// counters were `trip.flights?.length`, not `trip?.flights`), so a `null`/
// `undefined` `trip` throws here just as it would at the original call site.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * @typedef {Object} TripCounts
 * @property {number} flights - Number of flights on the trip.
 * @property {number} hotels - Number of hotels on the trip.
 * @property {number} carRentals - Number of car rentals on the trip.
 */

/**
 * Derives the flight/hotel/car-rental counts shown in the trip-info header.
 *
 * @param {Object} trip - The trip whose segment counts are derived.
 * @returns {TripCounts} The `{ flights, hotels, carRentals }` counts.
 */
export function getTripCounts(trip) {
  return {
    flights: trip.flights?.length || 0,
    hotels: trip.hotels?.length || 0,
    carRentals: trip.carRentals?.length || 0
  };
}

export default getTripCounts;
